import React, { useState, useEffect, useContext, Suspense } from "react"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import CardTravelIcon from "@material-ui/icons/CardTravel"
import { getSgById } from "@Services/shippingGroupService"
import { AuthContext } from "@Context/context/AuthContext"
import { GlobalContext } from "@Context/context/GlobalState"
import { useTranslation } from "react-i18next"
import useUserPermissions from "@Hooks/useUserPermissions"
import rsc from "@Config/resources"
import { useHistory } from "react-router"

import { LoadComponentByCondition } from "@Methods"
const Component = new LoadComponentByCondition("DetailShippingGroup").render()

const ShowShippingGroupScreen = () => {
  const { shippingGroupId } = useParams()
  const { handleRoutingBreadcrumbs } = useContext(GlobalContext)
  const [info, setInfo] = useState({})
  const [load, setLoad] = useState(true)
  const { user } = useContext(AuthContext)
  const { handleErrorSession } = useContext(GlobalContext)
  const { t } = useTranslation("global")
  const { permission, checking } = useUserPermissions({
    resources: [rsc.SgListSg],
  })
  const history = useHistory()

  useEffect(() => {
    if (!checking) {
      if (!permission[rsc.SgListSg]) return history.goBack()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checking])

  useEffect(() => {
    handleRoutingBreadcrumbs({
      titleHeader: t("detail-shipping-groups"),
      routes: [
        { name: t("orders"), route: "/shipping_groups" },
        {
          name: t("detail-shipping-groups"),
          route: `/shipping_groups/${shippingGroupId}`,
        },
      ],
      icon: <CardTravelIcon style={{ marginRight: 5, opacity: 0.5 }} />,
    })
    getSG()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSG = async () => {
    try {
      let response = await getSgById(
        user.user.token,
        shippingGroupId
      )
      if (response?.data?.message) {
        setInfo(response.data.message)
        setLoad(false)
      }
    } catch (error) {
      handleErrorSession({
        error: true,
        errorCode: error.response.status,
        messageError: error?.response?.data?.message,
      })
    }
  }

  return (
    <Suspense fallback>
      <Component info={info} orderid={info?.orderId || ""} load={load} />
    </Suspense>
  )
}

export default ShowShippingGroupScreen
